export interface WhiteLabel {
    BackgroundColor: string;
    BackgroundImage: string;
    Color1: string;
    Color2: string;
    Color3: string;
    Description: string;
    Id: number | null;
    LoginBackgroundImage: string;
    Name: string;
    Policy: string;
    PrimaryIcon: string;
    SecondaryIcon: string;
    Subdomain: string;
    SupportString: string;
}

export const defaultWhiteLabel = {
    BackgroundColor: Math.floor(Math.random() * 16777215).toString(16),
    BackgroundImage: '',
    Color1: Math.floor(Math.random() * 16777215).toString(16),
    Color2: Math.floor(Math.random() * 16777215).toString(16),
    Color3: Math.floor(Math.random() * 16777215).toString(16),
    Description: '',
    Id: null,
    LoginBackgroundImage: '',
    Name: '',
    Policy: '',
    PrimaryIcon: '',
    SecondaryIcon: '',
    Subdomain: '',
    SupportString: ''
};